import { render, staticRenderFns } from "./EngineConfig.vue?vue&type=template&id=a487ed40&scoped=true"
import script from "./EngineConfig.vue?vue&type=script&lang=js"
export * from "./EngineConfig.vue?vue&type=script&lang=js"
import style0 from "./EngineConfig.vue?vue&type=style&index=0&id=a487ed40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a487ed40",
  null
  
)

export default component.exports